<template>
  <div class="bg-soft bg-header-pattern py-10 md:py-12 lg:py-16 xl:py-20">
    <div class="max-w-screen-xl mx-auto lg:px-0 px-4">
      <PartialsToolsNavigation
        :tools="tools"
        :current_tool="toolsLocale.tool"
      />
      <div
        class="flex lg:items-start items-center gap-12 mt-12 lg:flex-row flex-col"
      >
        <template v-if="current_type == 'url'">
          <ToolsUrlTool />
        </template>
        <template v-else-if="current_type == 'document'">
          <ToolsDocumentTool />
        </template>
        <template v-else-if="current_type == 'image'">
          <ToolsImageTool />
        </template>
        <template v-else-if="current_type == 'vcard'">
          <ToolsBusinessCardTool />
        </template>
        <template v-else-if="current_type == 'multimedia'">
          <ToolsMultimediaTool />
        </template>
        <template v-else-if="current_type == 'map'">
          <ToolsMapTool />
        </template>
        <template v-else-if="current_type == 'wifi'">
          <ToolsWifiTool/>
        </template>
        <template v-else-if="current_type == 'event'">
          <ToolsEventTool/>
        </template>
        <template v-else-if="current_type == 'email'">
          <ToolsEmailTool/>
        </template>
        <template v-else-if="current_type == 'sms'">
          <ToolsSmsTool/>
        </template>
        <template v-else>
          <ToolsTextTool />
        </template>
        <PartialsPreviewQrCode />
      </div>
    </div>
  </div>
  <template v-if="current_type == 'text'">
    <PartialsQrCodeContent />
  </template>
  <template v-if="current_type == 'url'">
    <TypeUrlDefine />
  </template>
  <template v-if="current_type == 'document'">
    <TypeDocumentDefine />
  </template>
  <template v-if="current_type == 'image'">
    <TypeImageDefine />
  </template>
  <template v-if="current_type == 'multimedia'">
    <TypeMultimediaDefine />
  </template>
  <template v-if="current_type == 'vcard'">
    <TypeVcardDefine />
  </template>
  <template v-if="current_type == 'map'">
    <TypeMapDefine />
  </template>
  <PartialsFreeTestimal />
  <PartialsTrackQrWidget />
  <PartialsAgencyCarousel />
  <PartialsFunctionalComponent />
  <PartialsDialogGroup/>
</template>
<script lang="ts" setup>
import moment from "moment";
import ToolLocale from "~~/config/widgets/tools-widget";
import { useQrCreateStore } from "~~/stores/qrcreate";
const toolsLocale = new ToolLocale();
const tools = toolsLocale.data;
const current_type = toolsLocale.current_type;
const datajd = useDataJd();
const meta = useMeta();

const meta_tags = meta.metaTag({
  title: toolsLocale.tool.title,
  description: toolsLocale.tool.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/" + toolsLocale.current_type + ".png"),
});

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
useHead({
  title: toolsLocale.tool.title,
  meta: [
    { name: "description", content: toolsLocale.tool.description },
    { name: "keywords", content: toolsLocale.tool.keys },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});

useSchemaOrg([
  defineWebPage({
    name: toolsLocale.tool.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: toolsLocale.tool.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/" + toolsLocale.current_type + ".png"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: toolsLocale.tool.name,
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
definePageMeta({
  middleware: [
    function (to, from) {
      const type: string = to.params.type ? to.params.type + "" : "";
      const accept_types: Array<string> = [
        "text",
        "url",
        "document",
        "multimedia",
        "vcard",
        "map",
        "image",
        "event",
        "wifi",
        "email",
        "sms",
        "sw.js",
      ];
      // check extension
      if (type && !accept_types.includes(type.toLowerCase())) {
        console.log('Error for [TYPE] ============ '+type);
        throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
      }
    },
  ],
});
const qrstyle = useQrStyle();
const qrcreate = useQrCreateStore();
onMounted(() => {
  nextTick(() => {
    qrstyle.SetConfigStorage();
    if (!qrcreate.preload_font) {
      qrstyle.ImportFont();
    }
  });
});
</script>
